import React from 'react';
import PropTypes from 'prop-types';

import { Header } from '../../components/Header';

const SideNavigation = ({ expanded, children }) => (
  <div id="side-navigation" className={`off-canvas position-left reveal-for-large${expanded ? ' move-right' : ''}`}>
    <Header />
    {React.Children.toArray(children)}
  </div>
);

SideNavigation.propTypes = {
  expanded: PropTypes.bool,
  children: PropTypes.node,
};

SideNavigation.defaultProps = {
  expanded: false,
};

export default SideNavigation
